import {createSelector} from "reselect"
import * as WorkspaceSelectors from 'redux/workspace.selector'
import {RootState} from "redux/store"
import {ClientWorkspace} from "redux/models/appEnvironment"
import {ACESTargetType, Environment, UserDtoSummaryWithAces} from "components/admin/user/UserManager.types"
import {getConsolidatedAces} from "./users.selector";
import {ModelUser} from "./models/user"

export const getAssocClient = createSelector(
  (state: RootState) => state.user,
  (user: ModelUser) => user.userAssocClient
)

export type ConsolidatedAces = (Omit<UserDtoSummaryWithAces, "aces"> & {
  fullName: string
  aces: (UserDtoSummaryWithAces["aces"][0] & {
    targetType: ACESTargetType
    targetId: string
    targetObject: {
      id: number
      name: string
    } | null
  })[]
})

export const getAcesSelector = createSelector(
  (state: RootState) => state.user.userWithAces,
  (state: RootState) => WorkspaceSelectors.getAvailablesForAce(state as never),
  (state: RootState) => state.appEnvironment?.environment,
  (state: RootState) => state.environment?.datamodels,
  (aces, workspaces: ClientWorkspace[], environment: Environment, datamodels): ConsolidatedAces | undefined => {
    if (!aces) {
      return undefined
    }
    const consolidatedAces = getConsolidatedAces([aces], workspaces, environment, datamodels)
    return consolidatedAces.length === 1 ? consolidatedAces[0] : undefined
  },
)
